/** Größenlimits für Eingaben. */
export const LIMITS = {
  name: 120,
  title: 300,
  fieldText: 2_000,
  fieldLongText: 40_000,
  label: 120,
  password: { min: 10, max: 200 },
  email: 254,
  projectsPerUser: 50,
  seriesPerUser: 50,
  nodesPerProject: 5_000,
  entitiesPerProject: 3_000,
  typesPerProject: 100,
  connectionsPerProject: 20_000,
  fieldsPerType: 40,
  dynamicFieldsPerNode: 60,
  /** Beziehungen, die von einem Element ausgehen */
  relationsPerEntity: 200,
  turnsPerRelation: 50,
  /** Zustandsänderungen je Szene */
  changesPerScene: 200,
  /** Material je Szene (Ideen, Links, Bilder; PLAN.md §36) und die Länge einer Webadresse */
  materialPerScene: 200,
  materialUrl: 2_000,
  /** Story Beats (PLAN.md §42): Listen am Manuskript, Beats je Liste, Szenen je Beat, Beschreibung eines Beats */
  beatSheets: 20,
  beatsPerSheet: 60,
  scenesPerBeat: 50,
  beatDescription: 2_000,
  /** eigene Vorlagen für Beat-Listen je Konto */
  beatTemplatesPerUser: 50,
  documentsPerNode: 40,
  documentName: 80,
  documentText: 500_000,
  /** Versionen je Textdokument und ihr Titel */
  snapshotsPerDocument: 200,
  snapshotTitle: 120,
  groupsPerProject: 500,
  flagsPerTimeline: 200,
  timelinesPerProject: 20,
  assetBytes: 2_500_000,
  assetsPerProject: 2_000,
  /** ausgeblendete Hinweise je Projekt */
  dismissedIssues: 2_000,
} as const;
